/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Sandboxshell_Releasestatus_Comingsoon3Inputs */

const id_components_sandboxshell_releasestatus_comingsoon3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Comingsoon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segera hadir`)
};

const ms_components_sandboxshell_releasestatus_comingsoon3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Comingsoon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akan datang`)
};

const da_components_sandboxshell_releasestatus_comingsoon3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Comingsoon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommer snart`)
};

const de_components_sandboxshell_releasestatus_comingsoon3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Comingsoon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demnächst`)
};

const en_us2_components_sandboxshell_releasestatus_comingsoon3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Comingsoon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coming soon`)
};

const es_es2_components_sandboxshell_releasestatus_comingsoon3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Comingsoon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximamente`)
};

const es_mx2_components_sandboxshell_releasestatus_comingsoon3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Comingsoon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximamente`)
};

const fil_components_sandboxshell_releasestatus_comingsoon3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Comingsoon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Malapit na`)
};

const fr_components_sandboxshell_releasestatus_comingsoon3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Comingsoon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bientôt disponible`)
};

const it_components_sandboxshell_releasestatus_comingsoon3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Comingsoon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prossimamente`)
};

const hu_components_sandboxshell_releasestatus_comingsoon3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Comingsoon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hamarosan`)
};

const nl_components_sandboxshell_releasestatus_comingsoon3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Comingsoon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binnenkort`)
};

const no_components_sandboxshell_releasestatus_comingsoon3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Comingsoon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommer snart`)
};

const pl_components_sandboxshell_releasestatus_comingsoon3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Comingsoon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wkrótce`)
};

const pt_br2_components_sandboxshell_releasestatus_comingsoon3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Comingsoon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coming Soon`)
};

const pt_components_sandboxshell_releasestatus_comingsoon3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Comingsoon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em breve`)
};

const ro_components_sandboxshell_releasestatus_comingsoon3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Comingsoon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`În curând`)
};

const fi_components_sandboxshell_releasestatus_comingsoon3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Comingsoon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tulossa pian`)
};

const sv_components_sandboxshell_releasestatus_comingsoon3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Comingsoon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommer snart`)
};

const vi_components_sandboxshell_releasestatus_comingsoon3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Comingsoon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sắp ra mắt`)
};

const tr_components_sandboxshell_releasestatus_comingsoon3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Comingsoon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çok yakında`)
};

const cs_components_sandboxshell_releasestatus_comingsoon3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Comingsoon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Již brzy`)
};

const bg_components_sandboxshell_releasestatus_comingsoon3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Comingsoon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Очаквайте скоро`)
};

const ru_components_sandboxshell_releasestatus_comingsoon3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Comingsoon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скоро`)
};

const uk_components_sandboxshell_releasestatus_comingsoon3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Comingsoon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Незабаром`)
};

const ar_components_sandboxshell_releasestatus_comingsoon3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Comingsoon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قريبًا`)
};

const hi_components_sandboxshell_releasestatus_comingsoon3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Comingsoon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`जल्द आ रहा है`)
};

const th_components_sandboxshell_releasestatus_comingsoon3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Comingsoon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เร็ว ๆ นี้`)
};

const ja_components_sandboxshell_releasestatus_comingsoon3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Comingsoon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`近日公開`)
};

const zh_cn2_components_sandboxshell_releasestatus_comingsoon3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Comingsoon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coming Soon`)
};

const zh_hant1_components_sandboxshell_releasestatus_comingsoon3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Comingsoon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coming Soon`)
};

const ko_components_sandboxshell_releasestatus_comingsoon3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Comingsoon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coming Soon`)
};

/**
* | output |
* | --- |
* | "Coming soon" |
*
* @param {Components_Sandboxshell_Releasestatus_Comingsoon3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_sandboxshell_releasestatus_comingsoon3 = /** @type {((inputs?: Components_Sandboxshell_Releasestatus_Comingsoon3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Sandboxshell_Releasestatus_Comingsoon3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_sandboxshell_releasestatus_comingsoon3(inputs)
	if (locale === "ms") return ms_components_sandboxshell_releasestatus_comingsoon3(inputs)
	if (locale === "da") return da_components_sandboxshell_releasestatus_comingsoon3(inputs)
	if (locale === "de") return de_components_sandboxshell_releasestatus_comingsoon3(inputs)
	if (locale === "en-US") return en_us2_components_sandboxshell_releasestatus_comingsoon3(inputs)
	if (locale === "es-ES") return es_es2_components_sandboxshell_releasestatus_comingsoon3(inputs)
	if (locale === "es-MX") return es_mx2_components_sandboxshell_releasestatus_comingsoon3(inputs)
	if (locale === "fil") return fil_components_sandboxshell_releasestatus_comingsoon3(inputs)
	if (locale === "fr") return fr_components_sandboxshell_releasestatus_comingsoon3(inputs)
	if (locale === "it") return it_components_sandboxshell_releasestatus_comingsoon3(inputs)
	if (locale === "hu") return hu_components_sandboxshell_releasestatus_comingsoon3(inputs)
	if (locale === "nl") return nl_components_sandboxshell_releasestatus_comingsoon3(inputs)
	if (locale === "no") return no_components_sandboxshell_releasestatus_comingsoon3(inputs)
	if (locale === "pl") return pl_components_sandboxshell_releasestatus_comingsoon3(inputs)
	if (locale === "pt-BR") return pt_br2_components_sandboxshell_releasestatus_comingsoon3(inputs)
	if (locale === "pt") return pt_components_sandboxshell_releasestatus_comingsoon3(inputs)
	if (locale === "ro") return ro_components_sandboxshell_releasestatus_comingsoon3(inputs)
	if (locale === "fi") return fi_components_sandboxshell_releasestatus_comingsoon3(inputs)
	if (locale === "sv") return sv_components_sandboxshell_releasestatus_comingsoon3(inputs)
	if (locale === "vi") return vi_components_sandboxshell_releasestatus_comingsoon3(inputs)
	if (locale === "tr") return tr_components_sandboxshell_releasestatus_comingsoon3(inputs)
	if (locale === "cs") return cs_components_sandboxshell_releasestatus_comingsoon3(inputs)
	if (locale === "bg") return bg_components_sandboxshell_releasestatus_comingsoon3(inputs)
	if (locale === "ru") return ru_components_sandboxshell_releasestatus_comingsoon3(inputs)
	if (locale === "uk") return uk_components_sandboxshell_releasestatus_comingsoon3(inputs)
	if (locale === "ar") return ar_components_sandboxshell_releasestatus_comingsoon3(inputs)
	if (locale === "hi") return hi_components_sandboxshell_releasestatus_comingsoon3(inputs)
	if (locale === "th") return th_components_sandboxshell_releasestatus_comingsoon3(inputs)
	if (locale === "ja") return ja_components_sandboxshell_releasestatus_comingsoon3(inputs)
	if (locale === "zh-CN") return zh_cn2_components_sandboxshell_releasestatus_comingsoon3(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_sandboxshell_releasestatus_comingsoon3(inputs)
	return ko_components_sandboxshell_releasestatus_comingsoon3(inputs)
});
export { components_sandboxshell_releasestatus_comingsoon3 as "components.sandboxShell.releaseStatus.comingSoon" }